import React, { useState } from "react";
import Modal1 from "../../DIsplay/Modal/Modal1";
import payForTicket from "../../../controllers/Flight/payForTicket";
import { enqueueSnackbar } from "notistack";

function FlightAdminPayModal({ open, setOpen }) {
  const [loading, setLoading] = useState(false);
  const handleClose = () => setOpen?.(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const res = await payForTicket({
        flightBookingId: open,
      }).finally(() => {
        setLoading(false);
      });

      if (res?.return) {
        enqueueSnackbar("Payment successful. Ticket is now being processed.", {
          variant: "success",
        });

        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        enqueueSnackbar(
          res?.message ||
            res?.msg ||
            "Payment failed. Please try again or contact support.",
          { variant: "error" }
        );
      }
    } catch (err) {
      enqueueSnackbar(
        err?.message || "An unexpected error occurred. Please try again.",
        { variant: "error" }
      );
    }
  };

  return (
    <Modal1 open={open} setOpen={setOpen}>
      <div className="w-full max-w-md p-6">
        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Confirm Payment
        </h2>

        {/* Message */}
        <span className="text-sm text-gray-700 mb-1">
          Are you sure you want to continue with this payment?
        </span>
        <span className="text-sm text-gray-700 mb-4">
          <>The required amount will be deducted from the agent wallet.</>
        </span>

        {/* Actions */}
        <div className="flex justify-end gap-3 mt-4">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="px-4 py-2 w-40 flex text-center justify-center text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            {loading ? (
              <div className="buttonLoader"></div>
            ) : (
              <>Continue &amp; Pay</>
            )}
          </button>
        </div>
      </div>
    </Modal1>
  );
}

export default FlightAdminPayModal;
